/***
 *
 *   FOOTER (homepage)
 *   Static homepage footer
 *
 **********/

import { Animate, Link } from 'components/lib';
import Style from './footer.tailwind.js';
import { useTranslate } from 'app/translations';
import { rootPath } from 'utilities/routes.js';

const CONTACT_EMAIL = 'hello@valetify.io';

export function Footer(props) {
    const { _t } = useTranslate();

    return (
        <Animate type="slideup">
            <footer className={Style.footer}>
                <div className={`${Style.inner} ${Style.columns}`}>
                    <div>
                        <div className={Style.brand}>
                            {/* alt="" — decorative, the wordmark beside it carries the name */}
                            <img src="/assets/icon.png" alt="" className={Style.brandMark} />
                            Valetify
                        </div>
                        <div className={Style.tagline}>{_t('landing.footer.tagline')}</div>
                    </div>

                    <nav className={Style.column}>
                        <div className={Style.heading}>{_t('landing.footer.product')}</div>
                        <a href="/#capabilities" className={Style.link}>
                            {_t('landing.nav.features')}
                        </a>
                        <a href="/#integrations" className={Style.link}>
                            {_t('landing.nav.integrations')}
                        </a>
                        <a href="/#intake" className={Style.link}>
                            {_t('landing.footer.intake')}
                        </a>
                    </nav>

                    <nav className={Style.column}>
                        <div className={Style.heading}>{_t('landing.footer.account')}</div>
                        <Link
                            url={rootPath('/signin')}
                            color="secondary"
                            text={_t('signin.label')}
                            className={Style.link}
                        />
                        <Link
                            url={rootPath('/signup')}
                            color="secondary"
                            text={_t('signup.label')}
                            className={Style.link}
                        />
                    </nav>

                    <nav className={Style.column}>
                        <div className={Style.heading}>{_t('landing.footer.company')}</div>
                        <Link
                            url={rootPath('/contact')}
                            color="secondary"
                            text={_t('contact.label.one')}
                            className={Style.link}
                        />
                        <Link
                            url={rootPath('/terms')}
                            color="secondary"
                            text={_t('terms.label')}
                            className={Style.link}
                        />
                        <Link
                            url={rootPath('/privacy')}
                            color="secondary"
                            text={_t('privacy.label')}
                            className={Style.link}
                        />
                        <a href={`mailto:${CONTACT_EMAIL}`} className={Style.link}>
                            {CONTACT_EMAIL}
                        </a>
                    </nav>
                </div>

                <div className={Style.bottom}>{`© ${new Date().getFullYear()} Valetify`}</div>
            </footer>
        </Animate>
    );
}
